var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSetupAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.66699H24.5V16.0003H7.49996V4.66699Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.5003V21.667H25.9166V24.5003H28.75V25.917H25.9166V28.7503H24.5V25.917H21.6666V24.5003H24.5Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24996 0.416992C1.68518 0.416992 0.416626 1.68563 0.416626 3.25033V28.7503C0.416626 30.315 1.68518 31.5837 3.24996 31.5837H20.7273C21.9947 32.4762 23.5403 33.0003 25.2083 33.0003C27.1209 33.0003 28.8725 32.3112 30.2284 31.1678C30.6107 30.9335 30.9331 30.6111 31.1674 30.2288C32.3109 28.8729 33 27.1212 33 25.2087C33 23.5407 32.4758 21.9951 31.5833 20.7276V3.25033C31.5833 1.68563 30.3147 0.416992 28.75 0.416992H3.24996ZM28.75 18.2666V4.66699C28.75 3.88464 28.1157 3.25033 27.3333 3.25033H4.66663C3.88419 3.25033 3.24996 3.88464 3.24996 4.66699V27.3337C3.24996 28.116 3.88419 28.7503 4.66663 28.7503H18.2662C18.0368 28.3015 17.8496 27.8276 17.7099 27.3337H10.3333V20.2503H19.1976C20.6267 18.5199 22.7887 17.417 25.2083 17.417C26.4836 17.417 27.6874 17.7234 28.75 18.2666ZM11.75 21.667H14.5833V25.917H11.75V21.667ZM31.5833 25.2087C31.5833 28.7295 28.7291 31.5837 25.2083 31.5837C21.6875 31.5837 18.8333 28.7295 18.8333 25.2087C18.8333 21.6878 21.6875 18.8337 25.2083 18.8337C28.7291 18.8337 31.5833 21.6878 31.5833 25.2087Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSetupAs);
export default __webpack_public_path__ + "static/media/SaveSetupAs.35327f430082b3a3521e123069b9f965.svg";
export { ForwardRef as ReactComponent };